export default __webpack_public_path__ + "static/stocktwits-f923030aba3d7902da9c44e6b13595ea.png";